"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function openMediaDb({ openMediaDbApi }) {
    return (state, actions) => () => {
        openMediaDbApi().then(imageUrl => {
            if (imageUrl) {
                actions.effects.changeImageUrl({ imageUrl });
            }
        });
    };
}
exports.openMediaDb = openMediaDb;
//# sourceMappingURL=open-media-db.js.map